'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _PauseOutlined = _interopRequireDefault(require('./lib/icons/PauseOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _PauseOutlined;
exports.default = _default;
module.exports = _default;